let host: HTMLElement | undefined;

/**
 *
 *
 *
 *
 *
 */
export const useHost = (): HTMLElement =>
  host ??
  (() => {
    throw new Error(
      "Host element is not set. Ensure that the component is properly initialized and the host is set before using this function.",
    );
  })();
export const setHost = (h: HTMLElement | undefined): void => {
  host = h;
};
